import { render, staticRenderFns } from "./userPanel.vue?vue&type=template&id=4432db45"
import script from "./userPanel.vue?vue&type=script&lang=js"
export * from "./userPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports